import { Component } from '@angular/core';
import { HeaderData } from 'src/app/_interfaces/propertyDetail';

@Component({
  selector: 'app-chain-level-sidebar-layout',
  templateUrl: './chain-level-sidebar-layout.component.html',
  styleUrls: ['./chain-level-sidebar-layout.component.scss'],
})
export class ChainLevelSidebarLayoutComponent {
  pageHeader: HeaderData = {
    pageTitle: 'Access controller',
    propertyName: 'Chain Level',
  };
}
